import React from 'react';
import { RichText } from '../components/richText';
import styled from 'styled-components';
import { Asset } from '../types/asset';
import { Header, HeaderProps } from '../components/sections/header';
import { Document } from '@contentful/rich-text-types';
import { FooterProps, Footer } from '../components/sections/footer';
import { VLink } from '../components/other/vLink';
import SEO from '../components/seo';
import { Layout } from '../components/layout';
import { HeroBlog } from '../components/sections/heroBlog';
import Helmet from 'react-helmet';

const Container = styled.div`
  margin: 0 auto;
`;

const ShareThisContainer = styled.div`
    position: fixed;
    left: 0;
    top: 35vh;
    z-index: 5;
    transition: all 0.5s ease-in-out;
    width: auto;
    &.isOpen {
        width: 450px;
        @media (max-width: 768px) {
            width: 100%;
        }
    }
`;

interface Author {
  name: string;
  image: Asset;
  bio: string;
  website: string;
  twitter: string;
  linkedin: string;
}

interface Category {
  title: string;
  slug: string;
}

interface PageProps {
  pageContext: {
    title: string;
    description: string;
    content: Document;
    backgroundImage: Asset;
    publishedOn: string;
    categories: Category[];
    author: Author;
    header: HeaderProps;
    footer: FooterProps;
  };
}

export default ({ pageContext, location }: PageProps) => {
  const { title, description, author, mainImage, publishedOn, backgroundImage, content, categories, header, footer } = pageContext;

  return (
    <Layout title={title} description={description}>
      <Header logo={header.logo} navigationItems={header.navigationItems} disableInverse={false} />
      <Helmet>
          <meta name="og:image" content={mainImage.url} />
          <meta name="twitter:image" content={mainImage.url} />
      </Helmet>
      <HeroBlog
          headline={title}
          subtitle={description}
          backgroundImage={backgroundImage}
          publishedOn={publishedOn}
          author={author}
          location={location}
      />
      <Container className="max-w-2xl pt-0 mb-20">
        <RichText additionalClass={'blog__post--view px-6 md:px-0'} content={content} />
        <div className="px-10 md:px-0 pt-10 pb-8">
          <div className="mb-5 uppercase font-bold text-1.5xl">Categories</div>
          {categories.map((category, index) => (
            <div key={index} className="inline-block relative">
              <VLink className="inline-block uppercase text-1.5xl" to={`/category/${category.slug}`}>
                <div style={{textDecorationColor: '#46ff46'}} className={'underline'}>{category.title}</div>
              </VLink>
              {(index !== (categories.length - 1)) &&
                <span className="px-3 text-1.5xl">|</span>
              }
            </div>
          ))}
        </div>

      </Container>
      <Footer {...footer} />
    </Layout>
  );
};
